
<template>
  <div>
    <v-container>
      <div class="text-center background text border pt-2 pb-2">
        <v-container>
          <v-autocomplete
            ref="Item"
            v-model="item"
            :rules="[() => !!item || 'This field is required']"
            :items="itemsArray"
            label="Item"
            placeholder="Select..."
            required
            dark
          ></v-autocomplete>
        </v-container>

        <v-container>
          <div class="text-center">
            <v-btn @click="getItems(item)"> Search</v-btn>
          </div>
        </v-container>
      </div>
    </v-container>
  </div>
</template>



<script>
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      item: "",
    };
  },
  computed: {
    ...mapState(["itemsArray"]),
  },
  methods: {
    ...mapMutations(["setSearchOption", "getItemsByItemName", "setItem"]),
    getItems(item) {
      this.setItem(item);
      this.getItemsByItemName(item);
    },
    optionSelect(option) {
      this.option = option;
      this.setSearchOption(option);
    },
  },
};
</script>


<style scoped>
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: rgb(238, 195, 147);
}

.border {
  border-radius: 10px;
  border-width: 2px;
  border-color: white;
}

.hoverable {
  border-radius: 10px;
}

.hoverable:hover {
  cursor: pointer;
  border-radius: 10px;
  background-color: rgb(60, 60, 60);
}
</style>